export function generateTemporaryPassword(length: number = 16): string {
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const special = "!@#$%^&*";
  const all = lowercase + uppercase + numbers + special;

  const pick = (chars: string) =>
    chars[Math.floor(Math.random() * chars.length)];

  const passwordChars = [
    pick(lowercase),
    pick(uppercase),
    pick(numbers),
    pick(special),
  ];

  while (passwordChars.length < length) {
    passwordChars.push(pick(all));
  }

  for (let i = passwordChars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [passwordChars[i], passwordChars[j]] = [passwordChars[j], passwordChars[i]];
  }

  return passwordChars.join("");
}
